// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/ch-swap.svg';

export const ChSwap = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
